const MAX_REQUEST_DATA_SIZE = 30000000

export { MAX_REQUEST_DATA_SIZE }